import React from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { CrossClientResultDetails } from './CrossClientResultDetails'
import { CrossClientQueryLogicalQuestionDecomposition } from '../../../../models/CrossClient'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientClients, selectCrossClientClientsLoading } from '../../../../store/crossClient/crossClientResults'
import { CrossClientQueryResultDetails } from './hooks'

export interface CrossClientResultDetailsModalProps {
  resultDetails: CrossClientQueryResultDetails
  decomposition: CrossClientQueryLogicalQuestionDecomposition
}
export const CrossClientResultDetailsModal: React.FC<CrossClientResultDetailsModalProps> = ({ resultDetails, decomposition }) => {
  const clients = useAppSelector(selectCrossClientClients)
  const clientsLoading = useAppSelector(selectCrossClientClientsLoading)

  const { selectedResult, handleClearSelectedResult } = resultDetails

  const selectedResultClient = selectedResult ? clients[selectedResult.clientId] : null

  return (
    <Modal
      size='lg'
      show={!!selectedResult}
      header={<h4 className='p-2'>Match details</h4>}
      body={
        clientsLoading && !selectedResultClient ? (
          <div className='skeleton w-100 zocks-mb-2' style={{ height: '300px' }} />
        ) : selectedResult && selectedResultClient ? (
          <CrossClientResultDetails client={selectedResultClient} resultDetails={resultDetails} decomposition={decomposition} />
        ) : null
      }
      onHide={handleClearSelectedResult}
      showFooterActions={false}
    />
  )
}
